import EventTargetPolyfill from './EventTarget';
import Cookies from 'js-cookie';

let instance = null;

//  this.dispatchEvent(new Event("login"));

export default class LoginManager extends EventTargetPolyfill {
  static getSharedInstance() {
    if (!instance) {
      instance = new LoginManager();
      instance.init();
    }
    return instance;
  }

  constructor() {
    super();
    this.checkTimer = null;
    this.lastCheckedAccessToken = null;
    if (this.accessToken) {
      this.keepLogin = !!(Cookies.get('c_keep_session') || null);
    } else {
      this.keepLogin = false;
      Cookies.remove('c_keep_session');
    }
    this.resetTimer();
  }

  init() {}

  resetTimer() {
    if (this.checkTimer) {
      clearInterval(this.checkTimer);
      this.checkTimer = null;
    }
    this.lastCheckedAccessToken = this.accessToken;
    this.checkTimer = setInterval(() => {
      let currentAccessToken = this.accessToken;
      if (!!(currentAccessToken) != !!(this.lastCheckedAccessToken)) {
        clearInterval(this.checkTimer);
        this.checkTimer = null;
        window.location.reload();
      }
    }, 10000);
  }

  isLoggedIn() {
    return !!this.accessToken;
  }

  get accessToken() {
    return Cookies.get('c_api_token') || null;
  }

  setKeepLogin(keep) {
    if (keep) {
      Cookies.set('c_keep_session', '1', {
        expires: 365 * 10,
        path: '/',
      });
      this.keepLogin = true;
    } else {
      Cookies.remove('c_keep_session');
      this.keepLogin = false;
    }
  }

  setAccessToken(expiresSecIn, token) {
    if (this.keepLogin) {
      Cookies.set('c_api_token', token, {
        expires: expiresSecIn / 3600 / 24,
        path: '/',
      });
    } else {
      Cookies.set('c_api_token', token, {
        path: '/',
      });
    }
    this.resetTimer();
  }

  removeAccessToken() {
    Cookies.remove('c_api_token');
    Cookies.remove('c_keep_session');
    this.keepLogin = false;
    this.resetTimer();
  }

  invalidTokenDetected() {
    this.removeAccessToken();
    this.dispatchEvent(new Event('invalid_token'));
  }
}
